import throttle from 'lodash.throttle'

export default class TopScroll {
  constructor() {
    const btn = document.querySelector('#js-tothetop')
    if (!btn) return

    btn.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    })

    const checkScroll = () => {
      // console.log('[checkScroll]')
      btn.classList.toggle('is-visible', window.scrollY > 400)
    }

    window.addEventListener('scroll', throttle(checkScroll, 300))
  }
}
